module.exports = __webpack_public_path__ + "img/sword.34bdd5c9.png";